import { render, staticRenderFns } from "./behaviouralAnalysis.vue?vue&type=template&id=6a615d7f&scoped=true"
import script from "./behaviouralAnalysis.vue?vue&type=script&lang=js"
export * from "./behaviouralAnalysis.vue?vue&type=script&lang=js"
import style0 from "./behaviouralAnalysis.vue?vue&type=style&index=0&id=6a615d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a615d7f",
  null
  
)

export default component.exports